//
//
//
//
//
//
//
//
//
//
//

import NavMenu from '@/components/nav-menu.vue';
import Foot from '@/components/foot.vue';
import TipDialog from '@/components/tip-dialog.vue';
import storage from "@/common/storage";

export default {
    name: "website",
    data() {
        return {
            isShowTipDialog: storage.getVV() == 1,
            isBlur: false,
        };
    },
    components: {
        NavMenu,
        Foot,
        TipDialog
    },
    mounted() {
    },
    methods: {
        onCloseDialog() {
            this.isShowTipDialog =false
        },
        getBlur(status) {
            this.isBlur = status;
        },
    },
    
};



// WEBPACK FOOTER //
// ./src/views/website.vue